<template>
  <div class="view-container">
    <h1>Logs</h1>
    <p class="subtitle">Activity and system logs</p>
  </div>
</template>

<script>
export default {
  name: 'ActivityLogs',
}
</script>
